export const streamCredentials = {
  consumerKey: "FVCIFZaI3QB4k4W9fantXw==",
  consumerSecret: "skGqS3db1JYdlGrSbh6-XlReJXdpS3Ecn-LtADZtN9w="
};
